import * as Redux from 'redux'
import Reducers from '../reducers/reducers'
import apiMiddleware from './api_middleware'
import thunkMiddleware from './thunk_middleware'
import eventMiddleware from './event_middleware'
import { routerReducer } from 'react-router-redux'
import { persistStore } from 'redux-persist'
import { createReducerManager } from './next/reducer_manager'

const Store = (function(Redux, Reducers) {
  const preloadedState = window.__PRELOADED_STATE__,
    middleware = Redux.applyMiddleware(
      thunkMiddleware,
      apiMiddleware,
      eventMiddleware
    )
  const reducerManager = createReducerManager({
    ...Reducers,
    routing: routerReducer
  })
  const store = Redux.createStore(
    reducerManager.reduce,
    preloadedState,
    Redux.compose(
      middleware,
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        process.env.NODE_ENV === 'development'
        ? window.__REDUX_DEVTOOLS_EXTENSION__({
            trace: true,
            name: 'Le Tote'
          })
        : f => f
    )
  )
  store.reducerManager = reducerManager
  return store
})(Redux, Reducers)

export const persistor = persistStore(Store)

export default Store
